import axios from 'axios';
import axiosHelper from 'utils/axiosHelper';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_UTILISATEUR_INDICATEURS_REQUEST: 'FETCH_UTILISATEUR_INDICATEURS_REQUEST',
    FETCH_UTILISATEUR_INDICATEURS_SUCCESS: 'FETCH_UTILISATEUR_INDICATEURS_SUCCESS',
    FETCH_UTILISATEUR_INDICATEURS_FAILURE: 'FETCH_UTILISATEUR_INDICATEURS_FAILURE',
    INVALIDATE_UTILISATEUR_INDICATEURS: 'INVALIDATE_UTILISATEUR_INDICATEURS',
    UPDATE_CRITERES: 'UPDATE_CRITERES'

    
};

/**
 * FETCH_UTILISATEUR_INDICATEURS
 * ActionCreator pour la récupération des indicateurs
 */
const fetchUtilisateurIndicateursRequest = () => ({ type: Actions.FETCH_UTILISATEUR_INDICATEURS_REQUEST });
const fetchUtilisateurIndicateursSuccess = items => ({ type: Actions.FETCH_UTILISATEUR_INDICATEURS_SUCCESS, items });
const fetchUtilisateurIndicateursFailure = error => ({ type: Actions.FETCH_UTILISATEUR_INDICATEURS_FAILURE, error });
export const invalidateUtilisateurIndicateurs = () => ({ type: Actions.INVALIDATE_UTILISATEUR_INDICATEURS });

export const fetchUtilisateurIndicateurs = () => async (dispatch, getState) => {

    if (!getState().utilisateur.indicateurs.isLoading) {
        dispatch(fetchUtilisateurIndicateursRequest());

        let criteres = getState().utilisateur.indicateurs.criteres;

        try {
            let response = await axios.get('api/utilisateurs/indicateurs', { params: criteres, paramsSerializer: axiosHelper.transformRequestOptions });
            dispatch(fetchUtilisateurIndicateursSuccess(response.data));
        } catch (error) {
            console.error('fetchUtilisateurIndicateurs error : ', JSON.stringify(error, null, 2));
            dispatch(fetchUtilisateurIndicateursFailure(error));
        }
    }
};

const shoudFetchUtilisateurIndicateurs = state => {
    let indicateurs = state.utilisateur.indicateurs;

    if (indicateurs.items.length === 0) return true;
    else if (indicateurs.isLoading) return false;
    else return indicateurs.didInvalidate;
};

export const fetchUtilisateurIndicateursIfNeeded = () => (dispatch, getState) => {
    if (shoudFetchUtilisateurIndicateurs(getState())) {
        return dispatch(fetchUtilisateurIndicateurs());
    }
};



//
// ...
// ActionCreator pour les critères
//
export const updateUtilisateurIndicateursCriteres = (criteres) => ({ type: Actions.UPDATE_CRITERES, criteres });